import { Button, Form, FormProps, Input } from 'antd';
import React, { MouseEventHandler } from 'react';
import styled from '@emotion/styled';
import Checkbox from '../Checkbox';

const StyledForm = styled(Form)`
  > .ant-form-item {
    &:nth-of-type(2) {
      margin-bottom: 8px;
    }
  }
`;
const ContentActions = styled.div`
  color: #005eff;
  min-height: 80px;
`;

const StyledAgreement = styled(Checkbox)``;
export const SignInForm = ({
  onForgotPassword,
  ...props
}: Partial<
  FormProps & {
    onForgotPassword: MouseEventHandler;
  }
>) => {
  const [form] = Form.useForm();
  return (
    <StyledForm
      name="sign-in-form"
      form={form}
      layout="vertical"
      autoComplete="off"
      {...props}
    >
      <Form.Item label="Email" name="email">
        <Input></Input>
      </Form.Item>
      <Form.Item label="Password" name="password">
        <Input.Password></Input.Password>
      </Form.Item>
      <ContentActions>
        <Button
          onClick={onForgotPassword}
          name="forgot-password"
          type="link"
          size="small"
        >
          Forgot password
        </Button>
      </ContentActions>
      <Form.Item name="agreement" valuePropName="checked">
        <StyledAgreement>
          I agree to the{' '}
          <a
            href="https://www.icw.io/terms-conditions/"
            target="_blank"
            rel="noreferrer"
          >
            Terms & Conditions
          </a>
          ,{' '}
          <a
            href="https://www.icw.io/privacy-policy/"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
          , and <a href="https://www.icw.io/cookie-policy/">Cookies Policy</a>
        </StyledAgreement>
      </Form.Item>
      <Form.Item shouldUpdate>
        {(instance) => {
          const agreement = instance.getFieldValue('agreement');
          return (
            <Button
              disabled={!agreement}
              htmlType="submit"
              block
              type="primary"
              size="middle"
            >
              Login
            </Button>
          );
        }}
      </Form.Item>
    </StyledForm>
  );
};
